











































































import { Component, Vue } from "vue-property-decorator";
import * as firebase from "@/firebase";
import { Account } from "@/types";
import StripeCard from "@/components/StripeCard.vue";
import { functions } from "@/firebase";

@Component({ components: { StripeCard } })
export default class ProfileView extends Vue {
  editName = false;
  displayName: string | null = null;
  account: Account | null = null;

  async created() {
    this.displayName = this.user && this.user.displayName;
    const myUser = firebase.db.collection("users").doc(this.$store.state.user.data.uid);
    await this.$bind("account", myUser);
  }

  async updateProfile() {
    if (firebase.auth.currentUser) {
      await firebase.auth.currentUser.updateProfile({
        displayName: this.displayName,
      });
      this.$store.commit("changeLoginState", firebase.auth.currentUser);
      this.editName = false;
    }
  }

  async unsubscribe() {
    await functions.httpsCallable("cancelSubscription")();
  }

  get user() {
    return firebase.auth.currentUser;
  }

  get subscribed() {
    return !!this.account && this.account.subscribed;
  }

  get subscription() {
    return this.account && this.account.subscription;
  }

  get unpaid() {
    return !!this.account && this.account.subscribed && !this.account.paid;
  }
}
